import { useState, useEffect } from 'react';
import hubLayout from 'styles/css/hubLayout.module.css';
import { useModal } from 'components/common/ModalLayout';
import { useForm } from 'react-hook-form';
import { IdInputField, PwCheckInputField, PwInputField } from 'components/common/InputField';
import { NiceUi, onClickNicePass } from 'components/nice/NiceUi';
import { checkUserId, decryptAES256, textEncryptAes256, updatePwByFindPw } from 'api/api';
import { logout } from 'api/bridgeUser';

export function UserFindId() {
  /* 프로세스 (컨펌 필요함)
  1. 본인확인 필요하다고 하며 본인인증 버튼 클릭
  2. Nice 표준창으로 본인인증 후, 성공시 아이디 변경 페이지로 이동
  */
  // ****************************** 1. props, hook
  const redirect_code = new URLSearchParams(window.location.search).get('redirect_code');
  const redirect_data = new URLSearchParams(window.location.search).get('redirect_data');
  const { showModal } = useModal();
  // ****************************** 5. useEffect
  useEffect(() => {
    // NicePass 인증 결과 처리
    if (redirect_code === 'user_not_found') {
      showModal("alert", '해당하는 사용자 정보가 없습니다.');
    } else if (redirect_code === 'user_found' && redirect_data) {
      // showModal("alert", redirect_data);
    }
  }, []);

  return (
    <>
      <div className={`${hubLayout.cnt_box}`} style={{overflowY: "auto"}}>
        <div className={`${hubLayout.acc__cnt}`}>
          <div className={`${hubLayout.sec_title} ${hubLayout.fixed_title}`}>
            <h2>아이디 찾기</h2>
          </div>
          <div style={{ marginTop: "4rem" }}>
            {!redirect_data &&
              <ul className={`${hubLayout.inp_list}`}>
                <p><button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={() => onClickNicePass({ type: 'find_id', redirect_url: { success: '/user/find-id', fail: '/user/find-id' } })}>PASS인증</button></p>
              </ul>
            }
            {redirect_data &&
              <>
                <h2 className={`${hubLayout.cnt_title} ${hubLayout.tx_blue}`}>아이디 조회 완료</h2>
                <div className={`${hubLayout.acc_item_info}`}>
                  {JSON.parse(decryptAES256(redirect_data,process.env.REACT_APP_SECRET_KEY!,process.env.REACT_APP_SECRET_IV!)).map((user_id: string) =>
                    {
                      return (
                        <dl className={`${hubLayout.margin_0}`}>
                          <dt>ID</dt>
                          <dd>
                            <div className={`${hubLayout.display_flex}`}>
                              <p>{user_id}</p>
                            </div>
                          </dd>
                        </dl>
                      )
                    }
                    )
                  }
                </div>
              </>
            }
          </div>
          <div style={{display:'none'}}>
            <NiceUi />
          </div>
          <div className={`${hubLayout.btn_group} ${hubLayout.fixed_bottom_title} ${hubLayout.back_white}`}>
            <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.gray}`} onClick={() => logout()}>로그인으로</button>
          </div>
        </div>
      </div>
    </>
  );
}

export function UserFindPw() { 
  /* 프로세스 (컨펌 필요함)
  1. 아이디를 입력하여 후 조회 버튼 클릭
  2. 존재할 경우, 본인확인 필요하다고 하며 본인인증 버튼 클릭
  3. Nice 표준창으로 본인인증 후, 성공시 비밀번호 변경 페이지로 이동
  */
  interface UserUpdate {
    id?: string;
    password: string;
    passwordcheck?: string;
    access_token: string;
  }

  // ****************************** 1. props, hook
  const redirect_code = new URLSearchParams(window.location.search).get('redirect_code');
  const redirect_data = new URLSearchParams(window.location.search).get('redirect_data');
  const { showModal } = useModal();
  const [user, setUser] = useState<UserUpdate>(Object);
  const [accessToken, setAccessToken] = useState<string>('');
  // useForm
  const { register, formState: { errors, isValid } } = useForm<any>({
    mode: 'all',
  });
  // ****************************** 3. api
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setUser((prevData) => ({
      ...prevData,
      [name]: name === "id" ? value.toLowerCase() : value,
    }));
  };

  const checkId = async () => {
    const { id } = user;
    const result = await checkUserId({ id });
    if (result.code !== 200) {
      showModal('alert', '해당하는 사용자 정보가 없습니다.');
      return;
    }

    onClickNicePass({ type: 'find_pw', redirect_url: { success: '/user/find-pw', fail: '/user/find-pw' }, data: { id } });
  }

  const updateUserPw = async () => {
    if (!user.password || !user.passwordcheck  ) {
      showModal('alert', '비밀번호를 입력해주세요.');
      return;
    }
    if (!accessToken) {
      showModal('alert', '본인인증이 필요합니다.');
      return;
    }

    const data = {
      password: textEncryptAes256(user.password),
      access_token: textEncryptAes256(accessToken),
    }
    const userRes = await updatePwByFindPw(data);
    if (userRes.code === 200) {
      showModal('alert', '비밀번호 변경이 완료되었습니다. 로그인 후 이용해주세요.', {confirm: true, cancel: true},
        logout,
        logout
      );
    } else {
      showModal('alert', userRes.message);
    }
  };

  // ****************************** 5. useEffect
  useEffect(() => {
    // NicePass 인증 결과 처리
    if (redirect_code === 'user_not_found') {
      showModal("alert", '해당하는 사용자 정보가 없습니다.');
    } else if (redirect_code === 'user_not_match') {
      showModal("alert", '사용자 정보가 일치하지 않습니다.');
    } else if (redirect_code === 'user_found' && redirect_data) { 
      // showModal("alert", redirect_data);
      setAccessToken(decryptAES256(redirect_data,process.env.REACT_APP_SECRET_KEY!,process.env.REACT_APP_SECRET_IV!));
    }
  }, []);

  return (
    <>
      <div className={`${hubLayout.cnt_box}`} style={{overflowY: "auto"}}>
        <div className={`${hubLayout.acc__cnt}`}>
          <div className={`${hubLayout.sec_title} ${hubLayout.fixed_title}`}>
            <h2>비밀번호 찾기</h2>
          </div>
          
          <div style={{ marginTop: "4rem" }}>
            {!redirect_data &&
              <ul className={`${hubLayout.inp_list}`} >
                <IdInputField value={user} register={register} registerOptions={{ required: true, onChange: handleChange }} errors={errors} />
                <li className={`${hubLayout.inp_set} ${hubLayout.label_text}`}>
                  <p><button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={checkId} disabled={!isValid}>PASS인증</button></p>
                </li>
              </ul>
            }
            {redirect_data &&
              <>
                <h2 className={`${hubLayout.cnt_title} ${hubLayout.tx_blue}`}>새 비밀번호 설정</h2>
                <ul className={`${hubLayout.inp_list}`} >
                  <PwInputField value={user} register={register} registerOptions={{ required: true, onChange: handleChange }} errors={errors} />
                  <PwCheckInputField value={user} register={register} registerOptions={{ required: true, onChange: handleChange }} errors={errors} />
                  <li className={`${hubLayout.inp_set} ${hubLayout.label_text}`}>
                    <p><button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={updateUserPw} disabled={!isValid}>비밀번호 변경</button></p>
                  </li>
                </ul>
              </>
            }
          </div>
          <div style={{display:'none'}}>
            <NiceUi />
          </div>
          {!redirect_data &&
            <div className={`${hubLayout.btn_group} ${hubLayout.fixed_bottom_title} ${hubLayout.back_white}`}>
              <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.gray}`} onClick={() => logout()}>로그인으로</button>
            </div>
          }
        </div>
      </div>
    </>
  );
}